export function capitalize(text: string) {
  return text.replace(
    /\b([a-z])(.*?)(\b|$)/gi,
    (_, first: string, rest: string) => {
      return first.toUpperCase() + rest.toLowerCase();
    },
  );
}

export function formatForUrl(text: string): string {
  return text.toLowerCase().replace(/\s/g, "-");
}

export function formatForLabel(text: string, lowerCase = true): string {
  const normalized = text.replace(/[_-]+/g, " ").trim();
  const base = lowerCase ? normalized.toLowerCase() : normalized;
  const withAmp = base.replace(/\band\b/gi, "&");

  return capitalize(withAmp);
}

export function handlePlural(baseText = "", value = 0) {
  return `${baseText}${value > 1 ? "s" : ""}`;
}
